import React from 'react';
import { ReactComponent as PlusFile } from '../../assets/images/icons/plus-file.svg';

export default function PlusFileIcon(props) {
  return (
    <PlusFile className={`icon ${props.className}`} />
  );
}
